module.exports = __webpack_public_path__ + "img/billing.cecd6040.jpg";